import { Toast } from 'vant'
import NavBar from '@/components/Nav.vue';

import enums from '@/configs/enums.js';
import client from '@/configs/client.js';

export default {
    name: 'PaymentPage',
    components: {
        NavBar,
    },
    data() {
        return {
            back: false,
            states: enums.orderState
        }
    },
    created() {
        let backUrl = location.href + (location.href.indexOf('?') > -1 ? '&' : '?') + 'back=true';
        backUrl = encodeURIComponent(backUrl).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
        if (client.wechat) {
            if (! this.$route.query.code) {
                location.replace('https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx49e8ef10ad11c64f&redirect_uri=' + backUrl + '&response_type=code&scope=snsapi_base&state=#wechat_redirect');
            } else {
                this.$http.post('order/' + this.$route.params.id + '/payment/inside', {code: this.$route.query.code}).then(result => {
                    if (typeof WeixinJSBridge === 'undefined') {
                        if (document.addEventListener) {
                            document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(result.data.config), false)
                        } else if (document.attachEvent) {
                            document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady(result.data.config))
                            document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady(result.data.config))
                        }
                    } else {
                        this.onBridgeReady(result.data.config)
                    }
                });
            }
        } else if (! this.$route.query.back) {
            // 非支付回跳时进行H5支付
            this.$http.get('order/' + this.$route.params.id + '/payment/external').then(result => {
                location.replace(result.data.url + '&redirect_url=' + backUrl);
            })
        } else {
            // 支付回跳时检测订单结果
            this.$http.get('order/' + this.$route.params.id + '/check').then(result => {
                if (result.data.state != this.states.waiting) {
                    Toast(result.data.state == this.states.complete ? '支付成功' : '订单已关闭');
                    this.$router.replace('/order');
                }
            });
        }
    },
    methods: {
        onBridgeReady(data) {
            /* eslint-disable */
            WeixinJSBridge.invoke('getBrandWCPayRequest',
                {
                    "appId": "wx49e8ef10ad11c64f",
                    "timeStamp": data.timeStamp,
                    "nonceStr": data.nonceStr,
                    "package": data.package,
                    "signType": data.signType,
                    "paySign": data.paySign
                },
                (res) => {
                    if (res.err_msg == "get_brand_wcpay_request:ok" ) {
                        this.$router.replace('/order');   
                    }
                }
            );
            /* eslint-enable */
        }
    }
}